import { useIsAuthenticated } from '@azure/msal-react';
import { SideNav } from '../SideNav';

export const PageLayout = ({ children }) => {
    const isAuthenticated = useIsAuthenticated();

    return (
        <div className="app-shell">
            <SideNav />
            <main className={isAuthenticated ? 'main-with-sidebar' : 'main-full'}>
                {children}
            </main>
        </div>
    );
};
